export const BG_COLOR1 = '#FAF2EC';
export const COLOR1 = '#E3E1D9';
export const COLOR2 = '#204B3D';